import { render, staticRenderFns } from "./warehouseList.vue?vue&type=template&id=386b67f8&scoped=true"
import script from "./warehouseList.vue?vue&type=script&lang=js"
export * from "./warehouseList.vue?vue&type=script&lang=js"
import style0 from "./warehouseList.vue?vue&type=style&index=0&id=386b67f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b67f8",
  null
  
)

export default component.exports